import React from 'react';
import { connect } from 'react-redux';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ReactTable from 'react-table';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import FormattedDate from '../fields/dates/FormattedDate';
import dateformat from 'dateformat';
import UK_MTD_VAT_CONTROLLER from '../../controllers/ukMTDVAT';
import Modal from 'react-responsive-modal';
import ObligationsDetails from './ObligationsDetails';
import _ from 'underscore';
import NoData from '../page/NoData';
import Pagination from '../page/Pagination'
import {TableConfig} from '../../utils/appConfig';

const log = new Logger('OBLIGATIONS_VALUES', LOG_LEVELS.DEBUG);

class ObligationsValues extends React.Component {

    constructor(props) {
        super(props);
        this.onDetailsClick = this.onDetailsClick.bind(this);
        this.state = {
            open: false,
        };
    }
    onDetailsClick(cellInfo) {
        log.debug('onDetailsClick ', cellInfo);
        const params = {
            vatnumber: this.props.vatNumber,
            startdate: dateformat(cellInfo.start, 'yyyy-mm-dd'),
            enddate: dateformat(cellInfo.end, 'yyyy-mm-dd'),
            companyCode : this.props.companyCode
        };
        if(this.props !== undefined && typeof this.props.onGetVATReport === "function")
            this.props.onGetVATReport(params);
            this.setState({ open: true });
    }
    onCloseModal = () => {
        this.setState({ open: false });
    };
    render() {
        log.debug('render(): ', this.props);

        const columns = [
            {
                id : 'filingPeriod',
                Header: props => <span><LanguageStringResolver string='Obligations_FillingPeriod'/></span>,
                accessor: d => dateformat(d.start, 'yyyy-mm-dd') + ' to ' + dateformat(d.end, 'yyyy-mm-dd'),
                filterable:false
            }, {
                id: 'due',
                Header: props => <span><LanguageStringResolver string='Obligations_Due'/></span>,
                accessor: d =>  <FormattedDate value={d.due} />,
                filterable:false
            }, {
                id: 'received',
                Header: props => <span><LanguageStringResolver string='Obligations_HMRCReceived'/></span>,
                accessor: d => d.status === 'F' ? <FormattedDate value={d.received}/> : '',
                filterable:false
            },
            {
                id: "details",
                accessor: "SendingEnabled",
                Cell: ({ original }) => {
                    var enbleDetails = original.status === 'F' ? true : false;
                    return (
                        <button className={enbleDetails ?  "secondary" : "secondary disabled"} onClick={enbleDetails ? (e) => { this.onDetailsClick(original); } : (e) => {}}>
                            <LanguageStringResolver string='Obligations_Details'/>
                        </button>
                    );
                },
                sortable: false
            }]
        const modalStyle = {
            modal: {
                "maxWidth": "1080px",
                "width": "100%"
            }
        };

        const NoDataComponent = props => (
            <NoData
              noDataText="submittedReturns_NoData"
              {...props}
            />
          )

        return (
            <div>
                <ReactTable
                    minRows={0}
                    maxRows={0}
                    data={this.props.data}
                    loading={this.props.loading}
                    columns={columns}
                    onFetchData={this.props.onFetchData}
                    showPageJump={false}
                    pages={this.props.pages}
                    NoDataComponent={NoDataComponent}
                    className={this.props.data.length === 0 ? 'mb15 hide-header' : 'mb15'}
                    PaginationComponent={Pagination}
                    showPagination={this.props.data.length === 0 ? false : true}
                    defaultPageSize={TableConfig.PAGINATION.STANDARD_LEVEL_ONE_PAGE_SIZE}
                    pageSizeOptions={TableConfig.PAGINATION.STANDARD_PAGE_SIZE_OPTIONS}
                />
                <Modal open={this.state.open && this.props.reportData !== undefined && !_.isEmpty(this.props.reportData)} onClose={this.onCloseModal} center  modalStyles={modalStyle}>
                    <ObligationsDetails data={this.props.reportData}/>
                </Modal>
            </div>
        )

    }
}


// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);
    return {
        languages: state.languages,
        reportData: (state.ukMTDVAT && state.ukMTDVAT.report) || [],
    };
}
function mapDispatchersToProps(dispatch) {
    return {
        onGetVATReport: (queryParams) => {
            log.debug('onGetVATReport', queryParams);
            dispatch(UK_MTD_VAT_CONTROLLER.doGetReport(queryParams));
        }
    }
}
// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps,mapDispatchersToProps)(ObligationsValues);